var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdMetroIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.726562 11V0.0795898H2.21338L5.99268 5.79248L9.77197 0.0795898H11.2734V11H9.83057V2.45264L6.00732 8.09229H5.94873L2.14014 2.48193V11H0.726562Z",
    fill: "#788492"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdMetroIco);
export default __webpack_public_path__ + "static/media/ad_metro_ico.922028a2b691c22604b383f7f5886a49.svg";
export { ForwardRef as ReactComponent };